import { ReactNode } from 'react'
import Launchgoods from './launchgoods'
import Launchbrand from './launchbrand'
import useHook from './hooks'
import styles from './styles.module.scss'
import { Tabs } from 'antd'
import { OrderType } from './hooks'
export default function OrderAssurance() {
  const { changeOrder, checkedOrderKey } = useHook()
  const menuList: {
    key: OrderType
    component: ReactNode
    title: string
  }[] = [
    {
      key: 'LAUNCHGOODS',
      component: <Launchgoods />,
      title: '物料申请',
    },
    {
      key: 'LAUNCHBRAND',
      component: <Launchbrand />,
      title: '品牌申请',
    },
  ]

  const getMainContent = (key: string) => {
    return menuList.find((item) => item.key === key)?.component
  }

  return (
    <div className={styles.main}>
      <Tabs
        type="card"
        activeKey={checkedOrderKey}
        onTabClick={(keyname) => {
          changeOrder(keyname)
        }}
      >
        {menuList.map((item) => {
          return (
            <Tabs.TabPane tab={item.title} key={item.key}>
              {getMainContent(item.key)}
            </Tabs.TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}
import { ReactNode } from 'react'
import Launchgoods from './launchgoods'
import Launchbrand from './launchbrand'
import useHook from './hooks'
import styles from './styles.module.scss'
import { Tabs } from 'antd'
import { OrderType } from './hooks'
export default function OrderAssurance() {
  const { changeOrder, checkedOrderKey } = useHook()
  const menuList: {
    key: OrderType
    component: ReactNode
    title: string
  }[] = [
    {
      key: 'LAUNCHGOODS',
      component: <Launchgoods />,
      title: '物料申请',
    },
    {
      key: 'LAUNCHBRAND',
      component: <Launchbrand />,
      title: '品牌申请',
    },
  ]

  const getMainContent = (key: string) => {
    return menuList.find((item) => item.key === key)?.component
  }

  return (
    <div className={styles.main}>
      <Tabs
        type="card"
        activeKey={checkedOrderKey}
        onTabClick={(keyname) => {
          changeOrder(keyname)
        }}
      >
        {menuList.map((item) => {
          return (
            <Tabs.TabPane tab={item.title} key={item.key}>
              {getMainContent(item.key)}
            </Tabs.TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}
